import { Dispatch, SetStateAction } from "react";

import { Button } from "antd";
import { CloseButton } from "shared-components/Components/CustomIcons/CloseButton/web";
import { useActiveFiltersTags } from "../ActiveFiltersTags/ActiveFiltersTags.hook";
import { useSearchResultsFilters } from "../Filters/SearchResultsFilters.hook";

interface CloseSiderButtonProps {
	sider?: boolean
	setSider: Dispatch<SetStateAction<boolean>>;
	showSearchResults?: boolean;
}

export const CloseSiderButton = ({
	sider,
	setSider,
	showSearchResults = false,
}: CloseSiderButtonProps) => {
	const { filtersTagsToShow } = useActiveFiltersTags();
	const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();

	const handleCleanFilters = () => {
		const restoredValues = filtersTagsToShow.filter((item) => item.deleteable).reduce((acc, item) => {
			let valueToRestore;
	
			if (item.key === "property_type_id" ||
			  item.key === "bedrooms" ||
			  item.key === "bathrooms" ||
			  item.key === "constStatesID" ||
			  item.key === "neighborhood_id" ||
			  item.key === "facilitiesGroup"
			) valueToRestore = {[item.key]: []};
			else valueToRestore = item.onChangeObject;
	
			return { ...acc, ...valueToRestore };
		}, {});
	
		changeFilters(restoredValues)
	}

	if (!sider) return null;

	return (
		<div className={showSearchResults ? "closed-sider-footer-fixed" : "closed-sider-top-fixed"}>
			<Button
				style={{ width: showSearchResults ? "100%" : "auto"}}
				type={showSearchResults ? "primary" : "text"}
				onClick={() => setSider(false)}
				icon={!showSearchResults && <CloseButton />}
				children={
					showSearchResults &&
					"Ver" + " " + "propiedades"
				}
				className="show-properties"
			/>
			
			{showSearchResults && <Button
				type="text"
				onClick={() => handleCleanFilters()}
				children="Limpiar filtros"
				className="mobile-clean-filters"
			/>}
		</div>
	);
};
